import React from 'react';
import logo from '../../logo-gita-1.png';

import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';

import './navbar.styles.css';

const renderTooltip = (props) => (
    <Tooltip id="tooltip-bottom">
      {props.text}
    </Tooltip>
);

const NavBar = () => (
    <Navbar sticky="top" collapseOnSelect expand="lg" variant="dark" className="p-2 navbar-gps">
        <Navbar.Brand href="/" className="logo-gps">
            <img src={logo} width="43"
            className="d-inline-block align-top"
            alt="gpersable-logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="navlinks ml-auto">
                <Nav.Link href="#about" className="ml-3 mr-3">About</Nav.Link>
                <Nav.Link eventKey={2} href="#projects" className="ml-3 mr-3">Projects</Nav.Link>
                <OverlayTrigger placement="bottom" overlay={renderTooltip({ text: "Not available yet" })}>
                    <Nav.Link eventKey={3} className="ml-3 mr-3">Blog</Nav.Link>
                </OverlayTrigger>
                <Nav.Link eventKey={4} href="#contact" className="ml-3 mr-3">Contact</Nav.Link>
            </Nav>
        </Navbar.Collapse>
    </Navbar>
);

export default NavBar;
